import { Grid } from "@mui/material";
import SmartPredictSvg from "SvgIcons/SmartPredictSvg";
import CloseIcon from "@mui/icons-material/Close";
import { observer } from "mobx-react";
import { Tag } from "models/Tag";
import React from "react";
import { Divider } from "@mui/material";
import { useStore } from "utils/useStore";
import { PredictedTag } from "models/PredictedTag";
import { Answer } from "models/Answer";
import { WorkflowReviewStore } from "components/WorkflowReview/Stores/WorkflowReviewStore";
import AIExplanationCard from "./WFRAIExplanationCard";

interface AIExplanationCardsProps {
    activeTags: Tag[];
    predictedTags: PredictedTag[];
    answer: Answer;
    questionId: string;
}

const WFRAIExplanationCards = observer((props: AIExplanationCardsProps) => {
    const store = useStore(WorkflowReviewStore);

    const tagIdToPredictedTags = React.useMemo(() => {
        const result: Record<string, PredictedTag[]> = {};
        for (const predictedTag of props.predictedTags) {
            if (!result[predictedTag.tagId])
                result[predictedTag.tagId] = [predictedTag];
            else result[predictedTag.tagId].push(predictedTag);
        }
        return result;
    }, [props.predictedTags]);

    return (
        <Grid sx={{ marginTop: "0.25rem", paddingInline: 3, maxWidth: "100%" }}>
            <Grid
                container
                direction="column"
                sx={{
                    backgroundColor: "neutralGray.main",
                    borderRadius: 1,
                    border: "1px solid #E5E7EB",
                }}
            >
                <Grid
                    container
                    item
                    direction="row"
                    justifyContent="space-between"
                    sx={{ padding: 1.25 }}
                >
                    <SmartPredictSvg />
                    <CloseIcon
                        sx={{ color: "#A1A1AA", cursor: "pointer" }}
                        fontSize={"small"}
                        onClick={() =>
                            store.setShowAIExplanation(props.questionId, false)
                        }
                    />
                </Grid>
                {props.activeTags.map((tag, index) => (
                    <React.Fragment key={tag.id}>
                        {index > 0 && <Divider />}
                        <Grid
                            item
                            style={{
                                maxWidth: "100%",
                            }}
                        >
                            <AIExplanationCard
                                activeTag={tag}
                                predictedTags={tagIdToPredictedTags[tag.id]}
                                answer={props.answer}
                            />
                        </Grid>
                    </React.Fragment>
                ))}
            </Grid>
        </Grid>
    );
});

export default WFRAIExplanationCards;
